import React, { useState, useRef } from "react";
import UploadIcon from "assets/images/icons/upload-icon.svg";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import   "./UploadProfileImageStyle.css";

const UploadImageArea = ({ imageUrl, file, onFileChange, deleteFile }) => {
    const [crop, setCrop] = useState();
    const [completedCrop, setCompletedCrop] = useState();
    const [showCropModal, setShowCropModal] = useState(false);
    const [imgSrc, setImgSrc] = useState(null);
    const [scale, setScale] = useState(1);
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const inputRef = useRef();

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.classList.add("dragover");
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.classList.remove("dragover");
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.classList.remove("dragover");

        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile) {
            handleFileSelect(droppedFile);
        }
    };

    const handleFileSelect = (selectedFile) => {
        if (selectedFile) {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                setImgSrc(reader.result);
                setShowCropModal(true);
            });
            reader.readAsDataURL(selectedFile);
            inputRef.current.value = null;
        }
    };
    const handleCloseCropModal = () => {
        setShowCropModal(false);
        setImgSrc(null);
        setCrop(null);
        setCompletedCrop(null);
    };

    const onImageLoad = (e) => {
        // Get the loaded image element
        const image = e.currentTarget;
    
        // Create an off-screen canvas to draw the image onto
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
    
        // Get the image's original dimensions
        const width = image.naturalWidth;
        const height = image.naturalHeight;
    
        // Set canvas size to match the image
        canvas.width = width;
        canvas.height = height;
    
        // Draw the image onto the canvas
        ctx.drawImage(image, 0, 0);
    
        // Extract all pixel data from the image
        const imageData = ctx.getImageData(0, 0, width, height);
        const data = imageData.data; // A flat array of RGBA values
    
        // Initialize bounding box values to extreme edges
        let top = height, bottom = 0, left = width, right = 0;
    
        // Loop through each pixel
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const idx = (y * width + x) * 4;
    
                const r = data[idx];       // Red
                const g = data[idx + 1];   // Green
                const b = data[idx + 2];   // Blue
                const alpha = data[idx + 3]; // Alpha (transparency)
    
                // Consider a pixel visible if:
                // - it's not fully transparent (alpha > 10)
                // - OR it's not pure white (r+g+b < 750)
                const isVisible = alpha > 10 || (r + g + b < 750);
    
                if (isVisible) {
                    // Update the bounding box to include this pixel
                    if (x < left) left = x;
                    if (x > right) right = x;
                    if (y < top) top = y;
                    if (y > bottom) bottom = y;
                }
            }
        }
    
        // If a bounding box was found, set the crop to that area
        if (left < right && top < bottom) {
            const crop = {
                unit: "px",          // crop unit in pixels
                x: left,             // start X
                y: top,              // start Y
                width: right - left, // width of cropped area
                height: bottom - top // height of cropped area
            };
            setCrop(crop);
            setCompletedCrop(crop);
        } else {
            // Fallback crop if image has no visible pixels
            setCrop({ unit: "%", width: 90, x: 5, y: 5 });
        }
    };
    
    

    const getCroppedImg = (image, crop) => {
        const canvas = document.createElement("canvas");
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = crop.width;
        canvas.height = crop.height;
        const ctx = canvas.getContext("2d");
    
        // Clear canvas to preserve transparency
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width,
            crop.height
        );

        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            }, "image/png");
        });
    };

    const handleCropComplete = async () => {
        if (imgRef.current && completedCrop) {
            const croppedImageBlob = await getCroppedImg(imgRef.current, completedCrop);
            const croppedFile = new File([croppedImageBlob], "cropped-image.png", { type: "image/png" });
            const syntheticEvent = {
                target: {
                    files: [croppedFile],
                },
            };
            onFileChange(syntheticEvent);
            setShowCropModal(false);
        }
    };

    const handleZoomIn = () => {
        setScale((prevScale) => Math.min(prevScale + 0.1, 3));
    };

    const handleZoomOut = () => {
        setScale((prevScale) => Math.max(prevScale - 0.1, 0.5));
    };
       
    return (
        <div className="UploadImgModalArea">
            <div className="mdlUploadArea">
                {!file ? (
                    <div className="dropFileBox" onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop}>
                        {imageUrl ? <img src={imageUrl} className="uploadBoxImg" alt="Preview" /> : <img src={UploadIcon} className="uploadIcon" alt="Upload" />}
                        <h5 className="h5Title mb-2">Drop a file here to three</h5>
                        <p className="smText mb-3">Select a JPEG or PNG image file</p>
                        <div className="input-group fileUpload">
                            <label className="input-group-text" htmlFor="uploadFile">
                                Choose file
                            </label>
                            <input type="file" className="form-control" id="uploadFile" accept=".jpg, .jpeg, .png" ref={inputRef} onChange={(e) => handleFileSelect(e.target.files[0])} />
                        </div>
                    </div>
                ) : (
                    <div className="uploadShowImgBox">
                        <img src={URL.createObjectURL(file)} className="uploadBoxImg" alt="Preview" />
                        <button className="deleteImgBtn" onClick={deleteFile}>
                            Delete
                        </button>
                    </div>
                )}
            </div>

            <Modal show={showCropModal} onHide={handleCloseCropModal} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title className="cropImgTitle">Crop Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {imgSrc && (
                        <div className="zoomControlsContainer">
                            <div className="zoomControls mb-2">
                                <Button variant="outline-secondary" size="sm" onClick={handleZoomOut} className="zoomBtn">
                                   <svg width="11" height="4" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                       <rect width="12" height="2" fill="#1b1b1b"/>
                                    </svg>

                                </Button>
                                <Button variant="outline-secondary" size="sm" onClick={handleZoomIn} className="zoomBtn">
                                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="7" width="16" height="2" fill="#1b1b1b"/>
                                    <rect x="9" width="16" height="2" transform="rotate(90 9 0)" fill="#1b1b1b"/>
                                </svg>

                                </Button>
                            </div>
                            <ReactCrop
                                crop={crop}
                                onChange={(c) => setCrop(c)}
                                onComplete={(c) => setCompletedCrop(c)}
                            >
                                <img
                                    ref={imgRef}
                                    src={imgSrc}
                                    onLoad={onImageLoad}
                                    style={{ 
                                        maxWidth: "100%",
                                        transform: `scale(${scale})`,
                                        transformOrigin: "center center"
                                    }}
                                    alt="Crop me"
                                />
                            </ReactCrop>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="cropModalFooter">
                    <Button  onClick={() => setShowCropModal(false)} className="btn crpCancelBtn">
                        Cancel
                    </Button>
                    <Button  onClick={handleCropComplete} className="fillPrimarBtn cropSaveBtn">
                        Crop & Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default UploadImageArea;
